import { state, materialState, turkish } from "./../controls/state.js"
import { useSnapshot } from "valtio"
import React, { useRef, useState, useEffect, useLayoutEffect } from "react"
import { useGLTF } from "@react-three/drei"
import * as mats from "./mats.js"

function Aston(props) {
    const group = useRef()
    
    const {scene, nodes, materials} = useGLTF("models/aston.glb")
    const custom = mats.getMaterial()

    const snap = useSnapshot(state)
    const materialSnap = useSnapshot(materialState)
    
    const [hovered, set] = useState(null)
    useEffect(() => {
      const cursor = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><g filter="url(#filter0_d)"><path d="M29.5 47C39.165 47 47 39.165 47 29.5S39.165 12 29.5 12 12 19.835 12 29.5 19.835 47 29.5 47z" fill="${snap.items[hovered]}"/></g><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/><text fill="#000" style="white-space:pre" font-family="Inter var, sans-serif" font-size="10" letter-spacing="-.01em"><tspan x="35" y="63">${turkish[hovered]}</tspan></text></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath><filter id="filter0_d" x="6" y="8" width="47" height="47" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="2"/><feGaussianBlur stdDeviation="3"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>`
      const auto = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/></svg>`
      document.body.style.cursor = `url('data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(hovered ? cursor : auto)))}'), auto`
    }, [hovered])  
   
 
    return (
      <group
        ref={group}
        {...props}
        dispose={null}
        onPointerOver={(e) => (e.stopPropagation(), set(e.object.material.name))}
        onPointerOut={(e) => e.intersections.length === 0 && set(null)}
        onPointerMissed={() => (state.current = null)}
        onPointerDown={(e) => (e.stopPropagation(), (state.current = e.object.material.name))}>
      <group rotation={[-Math.PI / 2, 0, 0]} position={0,0,-60}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes['52L_Twin_Turbo_V12_Aluminium_0'].geometry}
              material={nodes['52L_Twin_Turbo_V12_Aluminium_0'].material}
            />
            <mesh
              geometry={nodes['52L_Twin_Turbo_V12_Aston_Martin_DB11_Signature_0'].geometry}
              material={materials.Aston_Martin_DB11_Signature}
            />
            <mesh geometry={nodes['52L_Twin_Turbo_V12_Engine_Yellow_0'].geometry} material={materials.Engine_Yellow} />
            <mesh geometry={nodes['52L_Twin_Turbo_V12_Hose_Clamps_0'].geometry} material={materials.Hose_Clamps} />
            <mesh geometry={nodes['52L_Twin_Turbo_V12_Hoses_0'].geometry} material={materials.Hoses} />
            <mesh
              geometry={nodes['52L_Twin_Turbo_V12_Painted_Black_0'].geometry}
              material={nodes['52L_Twin_Turbo_V12_Painted_Black_0'].material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.boot_ok_Badge_0.geometry} material={nodes.boot_ok_Badge_0.material} />
            <mesh geometry={nodes.boot_ok_Black_Metal_0.geometry} material={nodes.boot_ok_Black_Metal_0.material} />
            <mesh geometry={nodes.boot_ok_Black_0.geometry} material={nodes.boot_ok_Black_0.material} />
            <mesh geometry={nodes.boot_ok_Body_Color_0.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint} />
            <mesh geometry={nodes.boot_ok_Chrome_0.geometry} material={nodes.boot_ok_Chrome_0.material} />
            <mesh geometry={nodes.boot_ok_Leather_0.geometry} material={nodes.boot_ok_Leather_0.material} />
            <mesh geometry={nodes.boot_ok_Painted_Black_0.geometry} material={nodes.boot_ok_Painted_Black_0.material} />
            <mesh
              geometry={nodes.boot_ok_Rear_Lights_Housing_0.geometry}
              material={nodes.boot_ok_Rear_Lights_Housing_0.material}
            />
            <mesh
              geometry={nodes.boot_ok_Reverse_Lights_0.geometry}
              material={nodes.boot_ok_Reverse_Lights_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Chassis_Black_0.geometry} material={nodes.Chassis_Black_0.material} />
            <mesh geometry={nodes.Chassis_Body_Color_0.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint} />
            <mesh geometry={nodes.Chassis_Dark_Metal_0.geometry} material={nodes.Chassis_Dark_Metal_0.material} />
            <mesh geometry={nodes.Chassis_Leather_0.geometry} material={nodes.Chassis_Leather_0.material} />
            <mesh geometry={nodes.Chassis_Painted_Black_0.geometry} material={nodes.Chassis_Painted_Black_0.material} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Chassis_Bolts_Badge_0.geometry} material={nodes.Chassis_Bolts_Badge_0.material} />
          </group>
          <group rotation={[Math.PI, 0, 0]} scale={100}>
            <group position={[-0.81, -0.33, 1.38]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={-1}>
              <mesh
                geometry={nodes.Front_Left_Wheel_Badge_0.geometry}
                material={nodes.Front_Left_Wheel_Badge_0.material}
              />
              <mesh
                geometry={nodes.Front_Left_Wheel_Brake_Disc_0.geometry}
                material={nodes.Front_Left_Wheel_Brake_Disc_0.material}
              />
              <mesh
                geometry={nodes.Front_Left_Wheel_Painted_Black_0.geometry}
                material={nodes.Front_Left_Wheel_Painted_Black_0.material}
              />
              <mesh
                geometry={nodes.Front_Left_Wheel_Rim_White_0.geometry}
                material={nodes.Front_Left_Wheel_Rim_White_0.material}
              />
              <mesh
                geometry={nodes.Front_Left_Wheel_Tire_Sidewall_0.geometry}
                material={nodes.Front_Left_Wheel_Tire_Sidewall_0.material}
              />
              <mesh
                geometry={nodes.Front_Left_Wheel_Tire_Treads_0.geometry}
                material={nodes.Front_Left_Wheel_Tire_Treads_0.material}
              />
              <mesh
                geometry={nodes.Front_Left_Wheel_Tire_Valve_0.geometry}
                material={nodes.Front_Left_Wheel_Tire_Valve_0.material}
              />
            </group>
            <group position={[0.81, -0.33, 1.38]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={-1}>
              <mesh
                geometry={nodes.Front_Right_Wheel_Badge_0.geometry}
                material={nodes.Front_Right_Wheel_Badge_0.material}
              />
              <mesh
                geometry={nodes.Front_Right_Wheel_Brake_Disc_0.geometry}
                material={nodes.Front_Right_Wheel_Brake_Disc_0.material}
              />
              <mesh
                geometry={nodes.Front_Right_Wheel_Painted_Black_0.geometry}
                material={nodes.Front_Right_Wheel_Painted_Black_0.material}
              />
              <mesh
                geometry={nodes.Front_Right_Wheel_Rim_White_0.geometry}
                material={nodes.Front_Right_Wheel_Rim_White_0.material}
              />
              <mesh
                geometry={nodes.Front_Right_Wheel_Tire_Sidewall_0.geometry}
                material={nodes.Front_Right_Wheel_Tire_Sidewall_0.material}
              />
              <mesh
                geometry={nodes.Front_Right_Wheel_Tire_Treads_0.geometry}
                material={nodes.Front_Right_Wheel_Tire_Treads_0.material}
              />
              <mesh
                geometry={nodes.Front_Right_Wheel_Tire_Valve_0.geometry}
                material={nodes.Front_Right_Wheel_Tire_Valve_0.material}
              />
            </group>
            <group position={[-0.83, -0.33, -1.42]} rotation={[-Math.PI / 2, 0, -Math.PI]} scale={-1}>
              <mesh
                geometry={nodes.Rear_Left_Wheel_Badge_0.geometry}
                material={nodes.Rear_Left_Wheel_Badge_0.material}
              />
              <mesh
                geometry={nodes.Rear_Left_Wheel_Brake_Disc_0.geometry}
                material={nodes.Rear_Left_Wheel_Brake_Disc_0.material}
              />
              <mesh
                geometry={nodes.Rear_Left_Wheel_Painted_Black_0.geometry}
                material={nodes.Rear_Left_Wheel_Painted_Black_0.material}
              />
              <mesh
                geometry={nodes.Rear_Left_Wheel_Rim_White_0.geometry}
                material={nodes.Rear_Left_Wheel_Rim_White_0.material}
              />
              <mesh
                geometry={nodes.Rear_Left_Wheel_Tire_Sidewall_0.geometry}
                material={nodes.Rear_Left_Wheel_Tire_Sidewall_0.material}
              />
              <mesh
                geometry={nodes.Rear_Left_Wheel_Tire_Treads_0.geometry}
                material={nodes.Rear_Left_Wheel_Tire_Treads_0.material}
              />
              <mesh
                geometry={nodes.Rear_Left_Wheel_Tire_Valve_0.geometry}
                material={nodes.Rear_Left_Wheel_Tire_Valve_0.material}
              />
            </group>
            <group position={[0.83, -0.33, -1.42]} rotation={[Math.PI / 2, 0, 0]} scale={[-1, -1, -1]}>
              <mesh
                geometry={nodes.Rear_Right_Wheel_Badge_0.geometry}
                material={nodes.Rear_Right_Wheel_Badge_0.material}
              />
              <mesh
                geometry={nodes.Rear_Right_Wheel_Brake_Disc_0.geometry}
                material={nodes.Rear_Right_Wheel_Brake_Disc_0.material}
              />
              <mesh
                geometry={nodes.Rear_Right_Wheel_Painted_Black_0.geometry}
                material={nodes.Rear_Right_Wheel_Painted_Black_0.material}
              />
              <mesh
                geometry={nodes.Rear_Right_Wheel_Rim_White_0.geometry}
                material={nodes.Rear_Right_Wheel_Rim_White_0.material}
              />
              <mesh
                geometry={nodes.Rear_Right_Wheel_Tire_Sidewall_0.geometry}
                material={nodes.Rear_Right_Wheel_Tire_Sidewall_0.material}
              />
              <mesh
                geometry={nodes.Rear_Right_Wheel_Tire_Treads_0.geometry}
                material={nodes.Rear_Right_Wheel_Tire_Treads_0.material}
              />
              <mesh
                geometry={nodes.Rear_Right_Wheel_Tire_Valve_0.geometry}
                material={nodes.Rear_Right_Wheel_Tire_Valve_0.material}
              />
            </group>
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Engine_Badges_Badge_0.geometry} material={nodes.Engine_Badges_Badge_0.material} />
            <mesh
              geometry={nodes.Engine_Badges_Stickers_0.geometry}
              material={nodes.Engine_Badges_Stickers_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Engine_Bay_Badge_0.geometry} material={nodes.Engine_Bay_Badge_0.material} />
            <mesh
              geometry={nodes.Engine_Bay_Black_Metal_0.geometry}
              material={nodes.Engine_Bay_Black_Metal_0.material}
            />
            <mesh geometry={nodes.Engine_Bay_Black_0.geometry} material={nodes.Engine_Bay_Black_0.material} />
            <mesh
              geometry={nodes.Engine_Bay_Engine_Bay_White_0.geometry}
              material={nodes.Engine_Bay_Engine_Bay_White_0.material}
            />
            <mesh geometry={nodes.Engine_Bay_Misc_0.geometry} material={materials.Misc} />
            <mesh
              geometry={nodes.Engine_Bay_Painted_Black_0.geometry}
              material={nodes.Engine_Bay_Painted_Black_0.material}
            />
            <mesh geometry={nodes.Engine_Bay_Stickers_0.geometry} material={nodes.Engine_Bay_Stickers_0.material} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Engine_Bay_Bolts_Badge_0.geometry}
              material={nodes.Engine_Bay_Bolts_Badge_0.material}
            />
          </group>
          <group position={[81.33, 32.68, -138.24]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Front_Brake_Caliper_Chassis_0.geometry}
              material={nodes.Front_Brake_Caliper_Chassis_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Front_Bumper_Black_0.geometry} material={nodes.Front_Bumper_Black_0.material} />
            <mesh
              geometry={nodes.Front_Bumper_Body_Color_0.geometry}
              material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}
            />
            <mesh geometry={nodes.Front_Bumper_Chrome_0.geometry} material={nodes.Front_Bumper_Chrome_0.material} />
            <mesh geometry={nodes.Front_Bumper_Glass_0.geometry} material={nodes.Front_Bumper_Glass_0.material} />
            <mesh geometry={nodes.Front_Bumper_Grille_0.geometry} material={nodes.Front_Bumper_Grille_0.material} />
            <mesh
              geometry={nodes.Front_Bumper_Left_Indicator__Blinker_0.geometry}
              material={nodes.Front_Bumper_Left_Indicator__Blinker_0.material}
            />
            <mesh
              geometry={nodes.Front_Bumper_Painted_Black_0.geometry}
              material={nodes.Front_Bumper_Painted_Black_0.material}
            />
            <mesh
              geometry={nodes.Front_Bumper_Right_Indicator__Blinker_0.geometry}
              material={nodes.Front_Bumper_Right_Indicator__Blinker_0.material}
            />
            <mesh geometry={nodes.Front_Bumper_Splitter_0.geometry} material={materials.Splitter} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Front_Left_Brake_Caliper_Chassis_0.geometry}
              material={nodes.Front_Left_Brake_Caliper_Chassis_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Front_License_Plate_License_Plate_0.geometry}
              material={nodes.Front_License_Plate_License_Plate_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Glass_Glass_0.geometry} material={custom["fg" + materialSnap.items["front_glass"]]} material-color={snap.items.front_glass} />
            <mesh geometry={nodes.Glass_Glass_0001.geometry} material={nodes.Glass_Glass_0001.material} />
            <mesh geometry={nodes.Glass_Glass_0002.geometry} material={nodes.Glass_Glass_0002.material} />
            <mesh geometry={nodes.Glass_Glass_0003.geometry} material={nodes.Glass_Glass_0003.material} />
            <mesh geometry={nodes.Glass_Glass_0004.geometry} material={nodes.Glass_Glass_0004.material} />
            <mesh geometry={nodes.Glass_Glass_0005.geometry} material={nodes.Glass_Glass_0005.material} />
            <mesh geometry={nodes.Glass_Glass_0006.geometry} material={nodes.Glass_Glass_0006.material} />
            <mesh geometry={nodes.Glass_Glass_0007.geometry} material={nodes.Glass_Glass_0007.material} />
            <mesh geometry={nodes.Glass_Glass_0008.geometry} material={nodes.Glass_Glass_0008.material} />
            <mesh geometry={nodes.Glass_Glass_0009.geometry} material={nodes.Glass_Glass_0009.material} />
            <mesh geometry={nodes.Glass_Glass_0010.geometry} material={nodes.Glass_Glass_0010.material} />
            <mesh geometry={nodes.Glass_Glass_0011.geometry} material={nodes.Glass_Glass_0011.material} />
            <mesh geometry={nodes.Glass_Glass_0012.geometry} material={nodes.Glass_Glass_0012.material} />
            <mesh geometry={nodes.Glass_Glass_0013.geometry} material={nodes.Glass_Glass_0013.material} />
            <mesh geometry={nodes.Glass_Glass_0014.geometry} material={nodes.Glass_Glass_0014.material} />
            <mesh geometry={nodes.Glass_Glass_0015.geometry} material={custom["bsg" + materialSnap.items["back_side_glass"]]} material-color={snap.items.back_side_glass} />
            <mesh geometry={nodes.Glass_Glass_0016.geometry} material={custom["bsg" + materialSnap.items["back_side_glass"]]} material-color={snap.items.back_side_glass} />
            <mesh geometry={nodes.Glass_Glass_0017.geometry} material={custom["bg" + materialSnap.items["back_glass"]]} material-color={snap.items.back_glass} />
          </group>
          <group position={[0, 55.23, -232.02]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Hood_Badge_0.geometry} material={nodes.Hood_Badge_0.material} />
            <mesh geometry={nodes.Hood_Black_Metal_0.geometry} material={nodes.Hood_Black_Metal_0.material} />
            <mesh geometry={nodes.Hood_Body_Color_0.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint} />
            <mesh geometry={nodes.Hood_Chrome_0.geometry} material={nodes.Hood_Chrome_0.material} />
            <mesh geometry={nodes.Hood_Engine_Bay_White_0.geometry} material={nodes.Hood_Engine_Bay_White_0.material} />
            <mesh geometry={nodes.Hood_Gray_0.geometry} material={materials.Gray} />
            <mesh geometry={nodes.Hood_Grille_0.geometry} material={nodes.Hood_Grille_0.material} />
            <mesh geometry={nodes.Hood_Painted_Black_0.geometry} material={nodes.Hood_Painted_Black_0.material} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Interior_Alcantara_0.geometry} material={materials.Alcantara} />
            <mesh geometry={nodes.Interior_Aluminium_0.geometry} material={nodes.Interior_Aluminium_0.material} />
            <mesh geometry={nodes.Interior_Black_Metal_0.geometry} material={nodes.Interior_Black_Metal_0.material} />
            <mesh geometry={nodes.Interior_Black_0.geometry} material={nodes.Interior_Black_0.material} />
            <mesh geometry={nodes.Interior_Carpet_0.geometry} material={materials.Carpet} />
            <mesh geometry={nodes.Interior_Chrome_0.geometry} material={nodes.Interior_Chrome_0.material} />
            <mesh
              geometry={nodes['Interior_Dashboard_Put_any_color_you_want,_even_leather_0'].geometry}
              material={materials.Dashboard_Put_any_color_you_want_even_leather}
            />
            <mesh
              geometry={nodes.Interior_Headliner_any_color_you_want_0.geometry}
              material={materials.Headliner_any_color_you_want}
            />
            <mesh
              geometry={nodes.Interior_Interior_Trim_0.geometry}
              material={nodes.Interior_Interior_Trim_0.material}
            />
            <mesh geometry={nodes.Interior_Leather_0.geometry} material={nodes.Interior_Leather_0.material} />
            <mesh geometry={nodes.Interior_Mirror_0.geometry} material={nodes.Interior_Mirror_0.material} />
            <mesh geometry={nodes.Interior_Red_0.geometry} material={nodes.Interior_Red_0.material} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Interior_Buttons_Gauges_0.geometry} material={materials.Gauges} />
            <mesh
              geometry={nodes.Interior_Buttons_Interior_Letterings_Buttons_0.geometry}
              material={nodes.Interior_Buttons_Interior_Letterings_Buttons_0.material}
            />
            <mesh geometry={nodes.Interior_Buttons_Screen_0.geometry} material={materials.Screen} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Interior_Stitching_Badge_0.geometry}
              material={nodes.Interior_Stitching_Badge_0.material}
            />
            <mesh
              geometry={nodes.Interior_Stitching_Glass_0.geometry}
              material={nodes.Interior_Stitching_Glass_0.material}
            />
            <mesh
              geometry={nodes.Interior_Stitching_Red_0.geometry}
              material={nodes.Interior_Stitching_Red_0.material}
            />
            <mesh geometry={nodes.Interior_Stitching_Stitch_2_0.geometry} material={materials.Stitch_2} />
            <mesh
              geometry={nodes.Interior_Stitching_Stitch_0.geometry}
              material={nodes.Interior_Stitching_Stitch_0.material}
            />
          </group>
          <group position={[0, 57.87, 90.9]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <group position={[0, -0.02, 0]}>
              <mesh
                geometry={nodes.Left_Door_Buttons_Interior_Letterings_Buttons_0.geometry}
                material={nodes.Left_Door_Buttons_Interior_Letterings_Buttons_0.material}
              />
            </group>
            <mesh geometry={nodes.Left_Door_Glass_Badge_0.geometry} material={nodes.Left_Door_Glass_Badge_0.material} />
            <mesh geometry={nodes.Left_Door_Glass_Glass_0.geometry} material={custom["fsg" + materialSnap.items["front_side_glass"]]}
                  material-color={snap.items.front_side_glass} />
            <mesh
              geometry={nodes.Left_Door_Glass_Stitch_0.geometry}
              material={nodes.Left_Door_Glass_Stitch_0.material}
            />
            <mesh geometry={nodes.Left_Door_Aluminium_0.geometry} material={nodes.Left_Door_Aluminium_0.material} />
            <mesh geometry={nodes.Left_Door_Black_0.geometry} material={nodes.Left_Door_Black_0.material} />
            <mesh geometry={nodes.Left_Door_Body_Color_0.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint} />
            <mesh
              geometry={nodes.Left_Door_Interior_Trim_0.geometry}
              material={nodes.Left_Door_Interior_Trim_0.material}
            />
            <mesh geometry={nodes.Left_Door_Leather_0.geometry} material={nodes.Left_Door_Leather_0.material} />
            <mesh geometry={nodes.Left_Door_Mirror_0.geometry} material={nodes.Left_Door_Mirror_0.material} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Lights_Aluminium_0.geometry} material={nodes.Lights_Aluminium_0.material} />
            <mesh geometry={nodes.Lights_Black_0.geometry} material={nodes.Lights_Black_0.material} />
            <mesh geometry={nodes.Lights_Brake_Lights_0.geometry} material={nodes.Lights_Brake_Lights_0.material} />
            <mesh geometry={nodes.Lights_Chrome_0.geometry} material={nodes.Lights_Chrome_0.material} />
            <mesh geometry={nodes.Lights_Day_Lights_0.geometry} material={materials.Day_Lights} />
            <mesh geometry={nodes.Lights_High_Beams_0.geometry} material={materials.High_Beams} />
            <mesh
              geometry={nodes.Lights_Left_Indicator__Blinker_0.geometry}
              material={nodes.Lights_Left_Indicator__Blinker_0.material}
            />
            <mesh geometry={nodes.Lights_Lights_Glass_0.geometry} material={nodes.Lights_Lights_Glass_0.material} />
            <mesh geometry={nodes.Lights_Low_Beams_0.geometry} material={materials.Low_Beams} />
            <mesh geometry={nodes.Lights_Painted_Black_0.geometry} material={nodes.Lights_Painted_Black_0.material} />
            <mesh
              geometry={nodes.Lights_Rear_Lights_Housing_0.geometry}
              material={nodes.Lights_Rear_Lights_Housing_0.material}
            />
            <mesh
              geometry={nodes.Lights_Right_Indicator__Blinker_0.geometry}
              material={nodes.Lights_Right_Indicator__Blinker_0.material}
            />
            <mesh geometry={nodes.Lights_Taillights_0.geometry} material={materials.Taillights} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Radiator_Fan_Painted_Black_0.geometry}
              material={nodes.Radiator_Fan_Painted_Black_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Rear_Bumper_Black_Metal_0.geometry}
              material={nodes.Rear_Bumper_Black_Metal_0.material}
            />
            <mesh geometry={nodes.Rear_Bumper_Black_0.geometry} material={nodes.Rear_Bumper_Black_0.material} />
            <mesh
              geometry={nodes.Rear_Bumper_Body_Color_0.geometry}
              material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint}
            />
            <mesh
              geometry={nodes.Rear_Bumper_Brake_Lights_0.geometry}
              material={nodes.Rear_Bumper_Brake_Lights_0.material}
            />
            <mesh geometry={nodes.Rear_Bumper_Glass_0.geometry} material={nodes.Rear_Bumper_Glass_0.material} />
            <mesh
              geometry={nodes.Rear_Bumper_Left_Indicator__Blinker_0.geometry}
              material={nodes.Rear_Bumper_Left_Indicator__Blinker_0.material}
            />
            <mesh
              geometry={nodes.Rear_Bumper_Painted_Black_0.geometry}
              material={nodes.Rear_Bumper_Painted_Black_0.material}
            />
            <mesh
              geometry={nodes.Rear_Bumper_Reverse_Lights_0.geometry}
              material={nodes.Rear_Bumper_Reverse_Lights_0.material}
            />
            <mesh
              geometry={nodes.Rear_Bumper_Right_Indicator__Blinker_0.geometry}
              material={nodes.Rear_Bumper_Right_Indicator__Blinker_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Rear_Exhaust_TIps_Black_Metal_0.geometry}
              material={nodes.Rear_Exhaust_TIps_Black_Metal_0.material}
            />
            <mesh
              geometry={nodes.Rear_Exhaust_TIps_Black_0.geometry}
              material={nodes.Rear_Exhaust_TIps_Black_0.material}
            />
            <mesh
              geometry={nodes.Rear_Exhaust_TIps_Chrome_0.geometry}
              material={nodes.Rear_Exhaust_TIps_Chrome_0.material}
            />
          </group>
          <group position={[-81.66, 32.06, 124.77]} rotation={[-Math.PI / 2, 0, 0]} scale={[101.45, 100, 100]}>
            <mesh
              geometry={nodes.Rear_Left_Brake_Caliper_Chassis_0.geometry}
              material={nodes.Rear_Left_Brake_Caliper_Chassis_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Rear_License_Plate_License_Plate_0.geometry}
              material={nodes.Rear_License_Plate_License_Plate_0.material}
            />
          </group>
          <group position={[81.66, 32.06, 124.77]} rotation={[-Math.PI / 2, 0, 0]} scale={[101.45, 100, 100]}>
            <mesh
              geometry={nodes.Rear_Right_Brake_Caliper_Chassis_0.geometry}
              material={nodes.Rear_Right_Brake_Caliper_Chassis_0.material}
            />
          </group>
          <group position={[0, 57.87, 90.9]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Right_Door_Aluminium_0.geometry} material={nodes.Right_Door_Aluminium_0.material} />
            <mesh geometry={nodes.Right_Door_Black_0.geometry} material={nodes.Right_Door_Black_0.material} />
            <mesh geometry={nodes.Right_Door_Body_Color_0.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint} />
            <mesh
              geometry={nodes.Right_Door_Interior_Trim_0.geometry}
              material={nodes.Right_Door_Interior_Trim_0.material}
            />
            <mesh geometry={nodes.Right_Door_Leather_0.geometry} material={nodes.Right_Door_Leather_0.material} />
            <mesh geometry={nodes.Right_Door_Mirror_0.geometry} material={nodes.Right_Door_Mirror_0.material} />
          </group>
          <group position={[0, 57.87, 92.41]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Right_Door_Buttons_Interior_Letterings_Buttons_0.geometry}
              material={nodes.Right_Door_Buttons_Interior_Letterings_Buttons_0.material}
            />
          </group>
          <group position={[0, 57.87, 90.9]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Right_Door_Glass_Badge_0.geometry}
              material={nodes.Right_Door_Glass_Badge_0.material}
            />
            <mesh
              geometry={nodes.Right_Door_Glass_Glass_0.geometry}
              material={custom["fsg" + materialSnap.items["front_side_glass"]]}
              material-color={snap.items.front_side_glass}
            />
            <mesh
              geometry={nodes.Right_Door_Glass_Stitch_0.geometry}
              material={nodes.Right_Door_Glass_Stitch_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Seats_Aluminium_0.geometry} material={nodes.Seats_Aluminium_0.material} />
            <mesh geometry={nodes.Seats_Black_0.geometry} material={nodes.Seats_Black_0.material} />
            <mesh geometry={nodes.Seats_Leather_0.geometry} material={nodes.Seats_Leather_0.material} />
            <mesh geometry={nodes.Seats_Red_0.geometry} material={nodes.Seats_Red_0.material} />
          </group>
          <group position={[-38.61, 83.65, -27.83]} rotation={[-1.88, 0, 0]} scale={100}>
            <group position={[0.39, -0.2, -0.34]} rotation={[Math.PI / 10, 0, 0]}>
              <mesh
                geometry={nodes.Speedo_actually_RPM_Needle_Speedo_actually_RPM_Needle_0.geometry}
                material={materials.Speedo_actually_RPM_Needle}
              />
            </group>
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Spoiler_Body_Color_0.geometry} material={custom["c" + materialSnap.items["car_paint"]]} material-color={snap.items.car_paint} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Steering_Wheel_Badge_0.geometry} material={nodes.Steering_Wheel_Badge_0.material} />
            <mesh geometry={nodes.Steering_Wheel_Black_0.geometry} material={nodes.Steering_Wheel_Black_0.material} />
            <mesh
              geometry={nodes.Steering_Wheel_Dark_Metal_0.geometry}
              material={nodes.Steering_Wheel_Dark_Metal_0.material}
            />
            <mesh
              geometry={nodes.Steering_Wheel_Interior_Letterings_Buttons_0.geometry}
              material={nodes.Steering_Wheel_Interior_Letterings_Buttons_0.material}
            />
            <mesh
              geometry={nodes.Steering_Wheel_Stickers_0.geometry}
              material={nodes.Steering_Wheel_Stickers_0.material}
            />
            <mesh geometry={nodes.Steering_Wheel_Stitch_0.geometry} material={nodes.Steering_Wheel_Stitch_0.material} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh geometry={nodes.Trunk_Bolts_Badge_0.geometry} material={nodes.Trunk_Bolts_Badge_0.material} />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Trunk_Taillight_Glass_Lights_Glass_0.geometry}
              material={nodes.Trunk_Taillight_Glass_Lights_Glass_0.material}
            />
          </group>
          <group position={[0, 57.87, 1.51]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Windscreen_Wiper_Black_0.geometry}
              material={nodes.Windscreen_Wiper_Black_0.material}
            />
          </group>
        </group>
      </group>
    </group>
  )
}

export { Aston }